import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Music2 } from "lucide-react";
import NewsletterSignup from "@/components/NewsletterSignup";

const socialLinks = [
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Youtube, href: "#", label: "YouTube" },
  { icon: Music2, href: "#", label: "Spotify" },
];

const quickLinks = [
  { label: "Music", to: "/music" },
  { label: "Videos", to: "/videos" },
  { label: "Store", to: "/store" },
  { label: "Label", to: "/label" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="font-heading text-3xl text-[#D4AF37] mb-3">
              LUXIFER 6
            </h3>
            <p className="text-sm text-white/40 leading-relaxed">
              Turn Pain Into Gold
            </p>
            <p className="text-xs text-white/25 mt-2">3rd Degree Ent.</p>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5 font-semibold">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="text-sm text-white/40 hover:text-white transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5 font-semibold">
              Connect
            </h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                  className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 text-white/40"
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5 font-semibold">
              Newsletter
            </h4>
            <p className="text-sm text-white/40 mb-4">First to know. Every drop.</p>
            <NewsletterSignup tags={["footer"]} />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/25">
            &copy; {new Date().getFullYear()} Luxifer 6. All rights reserved.
          </p>
          <p className="text-xs text-white/25">3rd Degree Ent.</p>
        </div>
      </div>
    </footer>
  );
}
